function listenForLocationChanged(onLocationChanged) {
  // monkeypatch history api methods to get reliable calls for location changes
  // https://stackoverflow.com/a/41825103/11700562
  // and
  // https://stackoverflow.com/a/52809105/11483527
  window.history.pushState = function (f) {
    return function pushState() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var ret = f.apply(this, args);
      onLocationChanged();
      return ret;
    };
  }(window.history.pushState);

  window.history.replaceState = function (f) {
    return function replaceState() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      var ret = f.apply(this, args);
      onLocationChanged();
      return ret;
    };
  }(window.history.replaceState);

  window.addEventListener('popstate', function () {
    onLocationChanged();
  });
}

function listenForVisibilityChanged(onVisibilityChanged) {
  document.addEventListener('visibilitychange', function () {
    onVisibilityChanged();
  });
}

function listenForUnload(onUnload) {
  window.addEventListener('unload', function () {
    return onUnload();
  });
}

function attachBrowserListenersOnDOMContentLoaded() {
  var listeners = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var onLocationChanged = listeners.onLocationChanged,
      onVisibilityChanged = listeners.onVisibilityChanged,
      onUnload = listeners.onUnload,
      _listeners$onDOMConte = listeners.onDOMContentLoaded,
      onDOMContentLoaded = _listeners$onDOMConte === void 0 ? function () {} : _listeners$onDOMConte;

  if (onLocationChanged) {
    listenForLocationChanged(onLocationChanged);
  }

  if (onVisibilityChanged) {
    listenForVisibilityChanged(onVisibilityChanged);
  }

  if (onUnload) {
    listenForUnload(onUnload);
  }

  onDOMContentLoaded();
}

export default function attachBrowserListeners() {
  var listeners = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (document.readyState === 'interactive' || document.readyState === 'complete') {
    attachBrowserListenersOnDOMContentLoaded(listeners);
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      return attachBrowserListenersOnDOMContentLoaded(listeners);
    });
  }
}